/** Calendar date as YYYY-MM-DD, without shifting a date-only value through UTC. */
export function calendarDateIso(value: string | Date | null | undefined): string {
  if (!value) return '';
  if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}/.test(value)) return value.slice(0, 10);
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${date.getFullYear()}-${month}-${day}`;
}

export function isoToLocalDate(iso: string): Date | null {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(iso)) return null;
  const [year, month, day] = iso.split('-').map(Number);
  return new Date(year, month - 1, day);
}

export function existingAppointmentDosError(
  originalIso: string,
  chosenIso: string,
  todayIso: string,
): string {
  if (!chosenIso) return 'Choose a date of service.';
  if (originalIso && chosenIso < originalIso) {
    return 'Date of service cannot be before the appointment date.';
  }
  if (todayIso && chosenIso > todayIso) return 'Date of service cannot be after today.';
  return '';
}
